import { Gender, SimCardOperator } from "@/models/club";
import { Region } from "@/services/areaMessage/type";
import { SmsTemplate } from "@/services/template/type";

import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export enum MessageType {
  all = "all",
  messageGroup = "messageGroup",
  custom = "custom",
}

type SetRegionPayload = {
  id: string;
  region?: Region;
};

type SetTemplatePayload = {
  smsTemplate: SmsTemplate;
};

type SetInformationPayload = {
  gender?: Gender;
  simCardOperator?: SimCardOperator;
};

type SetCountPayload = {
  count: string;
};

type SetSendToPayload = {
  sendAll: boolean;
};

export type RegionMessageStore = {
  id?: string;
  region?: Region;
  smsTemplate?: SmsTemplate;
  gender?: Gender;
  simCardOperator?: SimCardOperator;
  count?: string;
  sendAll?: boolean;
  setRegion: (command: SetRegionPayload) => void;
  setTemplate: (command: SetTemplatePayload) => void;
  setInformation: (command: SetInformationPayload) => void;
  setCount: (command: SetCountPayload) => void;
  setSendToAll: (command: SetSendToPayload) => void;
  clear: () => void;
};

const useRegionMessageStore = create<RegionMessageStore>()(
  devtools(
    persist(
      (set) => ({
        id: undefined,
        smsTemplate: undefined,
        notifier: undefined,
        gender: undefined,
        simCardOperator: undefined,
        count: undefined,
        sendAll: true,
        setRegion: (command) =>
          set((state) => ({
            ...state,
            ...command,
          })),
        setTemplate: (command) =>
          set((state) => ({
            ...state,
            ...command,
          })),
        setInformation: (command) =>
          set((state) => ({
            ...state,
            ...command,
          })),
        setCount: (command) =>
          set((state) => ({
            ...state,
            ...command,
          })),
        setSendToAll: (command) =>
          set((state) => ({
            ...state,
            ...command,
            count: command?.sendAll ? undefined : state?.count,
          })),
        clear: () =>
          set(() => ({
            region: undefined,
            count: undefined,
            sendAll: true,
            id: undefined,
            smsTemplate: undefined,
            notifier: undefined,
            gender: undefined,
            simCardOperator: undefined,
          })),
      }),

      { name: "createRegionMessageState" }
    )
  )
);

export default useRegionMessageStore;
